import { NoteListModel } from "../note/note.list.model";
import { EmployeeEditModel } from "./employee.edit.model";

export class StaffDetailModel extends EmployeeEditModel {
    public name: string;
    public managerName: string;
    public pinnedNotes: NoteListModel[];
}